
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'


export default {
components: {
Swiper,
SwiperItem
},
data () {
return {
$vue: '',
needDiagnoseNum: '',
alreadyDiagnoseNum: '',
swiperHeight: 0.55,
content1: 'content1',
content2: 'content2',
active1: 'active1',
active2: 'active2',
swiperAuto: true,
swiperLoop: true,
swiperList: [{
url: '',
img: '',
title: ''
}, {
url: '',
img: '',
title: ''
}, {
url: '',
img: '',
title: ''
}]
}
},
methods: {

async initDiagnoseNum () {
let suc = await this.$http.get(this.$vue.getData('INDEX_DIAGNOSE_NUM_URL'))
if (suc.data.result === '1') {
this.needDiagnoseNum = suc.data.data.dzdCaseNum
this.alreadyDiagnoseNum = suc.data.data.yzdCaseNum
}
},

async initNewsSwiper () {
let suc = await this.$http.post(this.$vue.getData('NEWS_SWIPPER_URL'))
if (suc.data.result === '1') {
let list = suc.data.data

for (let i = 0; i < list.length; i++) {
this.swiperList[i].img = list[i].NEWS_IMG







}
}
},
goDzdList () {
this.active1 = 'active3'
this.$router.push({name: 'DzdCaseList'})
},
goYzdList () {
this.active2 = 'active4'
this.$router.push({name: 'YzdCaseList'})
}
},
beforeMount () {
this.$vue = this
this.initDiagnoseNum()
this.initNewsSwiper()
}
}



// WEBPACK FOOTER //
// ./src/components/doctor/homePage.vue